import datos from "src/services/datos";
import Swal from "sweetalert2";

const objectTipoDocumento = new datos("documento_tipo");

export const getTipoDocumento = async () => {
  objectTipoDocumento.addCondition("documento_tipo", "id", 0, ">");

  const response = await objectTipoDocumento.get();

  if (response) {
    return response.wsResponse.documento_tipo;
  }
  return response;
};

export const getTipoDocumentoPaginated = async (limit, offset) => {
  objectTipoDocumento.addCondition("documento_tipo", "id", 0, ">");
  objectTipoDocumento.addLimitCondition(limit, offset);
  const response = await objectTipoDocumento.get();
  /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

  let result = {};
  if (!response.wsResponse.empty) {
    result = {
      data: [...response.wsResponse.documento_tipo],
      total_records: response.wsResponse.total_records,
    };
    return result;
  }
};

export const postTipoDocumento = async (estado) => {
  if (estado) {
    const data = {
      id: estado.id,
      nombre: estado.detalle,
    };
    const response = await objectTipoDocumento.insert(data);
    if (response) {
      return response.wsResponse.documento_tipo;
    }
  }
  return false;
};

export const deleteTipoDocumento = async (id) => {
  let status = false;
  await Swal.fire({
    title: "Esta seguro de que desea eliminar este tipo de documento?",
    text: "Si sigue adelante, no se podran revertir los cambios!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, quiero eliminarlo!",
    cancelButtonText: "No, no estoy seguro!",
  }).then(async (result) => {
    if (result.isConfirmed) {

      const userData = new datos('documento_tipo');
      let data = {
        id: id
      }
      const response = await userData.delete(data);

      if (response.status === "true") {

        status = true;
        await Swal.fire(
          "Eliminado!",
          "El Tipo de Documento ha sido eliminado exitosamente.",
          "success"
        );
      } else {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message
        });
      }
    }
  });
  return status;
};
